import { Link } from "react-router-dom";
import { playStoreUrl, trackCta } from "../../utils/tracking";
import playBadge from "../../assets/images/badges/google-play-badge.svg";
import appStoreBadge from "../../assets/images/badges/app-store-badge.svg";
import { IOS_LIVE, appStoreUrl } from "../../config/stores";

function AppleGlyph({ className = "" }) {
    return (
        <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="currentColor">
            <path d="M16.37 1.43c0 1.14-.42 2.2-1.13 2.98-.85.95-2.07 1.62-3.2 1.53-.14-1.1.43-2.27 1.1-3 .78-.86 2.1-1.52 3.23-1.51ZM20.5 17.1c-.55 1.27-.82 1.84-1.53 2.96-.99 1.56-2.39 3.5-4.12 3.52-1.54.01-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.02-3.05-1.77-4.04-3.33C-.07 15.9-.37 10.8 1.37 8.1c1.24-1.92 3.2-3.04 5.03-3.04 1.87 0 3.05 1.02 4.6 1.02 1.5 0 2.42-1.02 4.58-1.02 1.64 0 3.37.89 4.6 2.43-4.04 2.21-3.38 7.99.32 9.6Z" />
        </svg>
    );
}

/**
 * The two ways in: the official Google Play badge, and for iPhone either the official App
 * Store badge (once REACT_APP_APP_STORE_URL is set) or a waitlist button sized to match.
 * `tone="dark"` is for ink panels. `placement` tags the click for analytics.
 */
export default function StoreButtons({ placement, className = "", compact = false, tone = "light" }) {
    const h = compact ? "h-12" : "h-[52px]";
    const ios =
        tone === "dark"
            ? "border-white/20 bg-white/[0.06] text-white hover:border-white/40 hover:bg-white/10"
            : "border-line-strong bg-card text-ink hover:border-[#C8C6C0] hover:bg-raised";
    return (
        <div className={`flex flex-wrap items-center gap-3 ${className}`}>
            <a
                href={playStoreUrl(placement)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackCta(placement, { cta_label: "google_play" })}
                className="inline-flex transition-transform duration-150 hover:-translate-y-px active:scale-[0.98]"
            >
                <img src={playBadge} alt="Get it on Google Play" className={`${h} w-auto`} width={176} height={52} />
            </a>
            {IOS_LIVE ? (
                <a
                    href={appStoreUrl({ campaign: placement })}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackCta(placement, { cta_label: "app_store" })}
                    className="inline-flex transition-transform duration-150 hover:-translate-y-px active:scale-[0.98]"
                >
                    <img src={appStoreBadge} alt="Download on the App Store" className={`${h} w-auto`} width={156} height={52} />
                </a>
            ) : (
            <Link
                to="/waitlist?platform=ios"
                onClick={() => trackCta(placement, { cta_label: "ios_waitlist" })}
                className={`inline-flex ${h} items-center gap-2.5 rounded-[10px] border pl-3.5 pr-4 transition-colors duration-200 active:scale-[0.98] ${ios}`}
            >
                <AppleGlyph className="h-[22px] w-[22px]" />
                <span className="flex flex-col text-left leading-none">
                    <span className={`text-[10px] font-medium uppercase tracking-[0.08em] ${tone === "dark" ? "text-white/60" : "text-muted"}`}>
                        iPhone · coming soon
                    </span>
                    <span className="mt-1 text-[15px] font-semibold tracking-[-0.01em]">Join the waitlist</span>
                </span>
            </Link>
            )}
        </div>
    );
}
